var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { PromptModalData, ShowPromptModalActions } from './show.prompt.modal.provider';
import { MatDialogRef } from '@angular/material';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
var ShowPromptModalComponent = /** @class */ (function (_super) {
    __extends(ShowPromptModalComponent, _super);
    function ShowPromptModalComponent(dialogRef, actions, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.messages = [];
        _this.doNotShowPromptModal = false;
        _this.title = data.title;
        _this.message = data.message;
        _this.messages = data.messages;
        _this.isShowCheckbox = data.isShowCheckbox;
        return _this;
    }
    ShowPromptModalComponent.prototype.close = function () {
        console.log(this.doNotShowPromptModal);
        if (this.isShowCheckbox) {
            if (this.doNotShowPromptModal) {
                localStorage.setItem(localStorageKeys.doNotShowRemoveSuccessfullyModal, this.doNotShowPromptModal ? "true" : "false");
            }
        }
        this.dialogRef.close();
    };
    return ShowPromptModalComponent;
}(BaseComponent));
export { ShowPromptModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.prompt.modal/show.prompt.modal.component.ts.pre-build-optimizer.js